'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIIconHolder = require('../icon/UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

var _BrowserTest = require('../utils/BrowserTest');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _LoadingConstants = require('./LoadingConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getSpinnerSize = function getSpinnerSize(sizeName) {
  return _LoadingConstants.SIZE_OPTIONS[sizeName] || _LoadingConstants.SIZE_OPTIONS['sm'];
};

var privateSpin = (0, _styledComponents.keyframes)(['100%{transform:rotate(360deg)}']);

var privateDash = (0, _styledComponents.keyframes)(['0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-50;}100%{stroke-dasharray:90,150;stroke-dashoffset:-140;}']);

var SpinnerOuter = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingSpinner__SpinnerOuter'
})(['position:relative;align-items:center;color:', ';display:flex;flex-direction:', ';justify-content:', ';', ';'], function (props) {
  return props.use === 'on-dark' ? _colors.OLAF : 'currentColor';
}, function (props) {
  return props.layout === 'centered' && 'column';
}, function (props) {
  return props.layout === 'centered' && 'center';
}, function (props) {
  return props.grow ? 'width: 100%; height: 100%;' : 'margin: 8px';
});

var SpinnerInner = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingSpinner__SpinnerInner'
})(['align-items:center;display:flex;height:', ';justify-content:center;width:', ';'], function (props) {
  return getSpinnerSize(props.size);
}, function (props) {
  return getSpinnerSize(props.size);
});

var SpinnerLabel = _styledComponents2.default.span.withConfig({
  displayName: 'UILoadingSpinner__SpinnerLabel'
})(['margin-top:', ';&:not(:empty){margin-left:', ';margin-right:', ';}'], function (props) {
  return props.layout === 'centered' && _sizes.BASE_ICON_SPACING_X;
}, _sizes.BASE_ICON_SPACING_X, _sizes.BASE_ICON_SPACING_X);

var ResultSpinner = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingSpinner__ResultSpinner'
})(['align-items:center;display:flex;justify-content:center;opacity:0;position:absolute;transform:scale(0.7);transition:opacity 0.2s cubic-bezier(0.42,0,0.58,1) 0.1s,transform 0.3s cubic-bezier(0.2,0.9,0.3,2) 0.1s;', ''], function (_ref) {
  var showResult = _ref.showResult;
  return showResult && 'opacity: 1;\n    position: relative;\n    transform: scale(1);\n  ';
});

var SpinnerWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingSpinner__SpinnerWrapper'
})(['opacity:1;transition:opacity 0.2s cubic-bezier(0.42,0,0.58,1),transform 0.2s cubic-bezier(0.89,0.03,0.68,0.22);', ' ', ''], (0, _BrowserTest.isIE11)() && (0, _styledComponents.css)(['animation:', ' 2s linear infinite;'], privateSpin), function (_ref2) {
  var showResult = _ref2.showResult;
  return showResult && 'margin-left: -1px;\n    opacity: 0;\n    transform: scale(.7);\n    width: 1px;\n  ';
});

var Ring = _styledComponents2.default.svg.withConfig({
  displayName: 'UILoadingSpinner__Ring'
})(['display:block;max-width:100%;']);

var RingPath = _styledComponents2.default.circle.withConfig({
  displayName: 'UILoadingSpinner__RingPath'
})(['animation:', ' 2s cubic-bezier(0.42,0,0.58,1) infinite,', ' 2s linear infinite;stroke-dasharray:none;stroke-dashoffset:0;stroke-linecap:round;transform-origin:center;', ''], privateDash, privateSpin, (0, _BrowserTest.isIE11)() && 'stroke-dasharray: 50, 150;');

var getComputedStyle = function getComputedStyle(style, grow, minHeight) {
  if (minHeight) {
    var computedStyle = _extends({}, style, { minHeight: minHeight });
    if (!grow) computedStyle.height = '1rem';
    return computedStyle;
  }
  return style;
};

var resultIconStyles = { lineHeight: 'inherit', verticalAlign: 'middle' };

var UILoadingSpinner = (0, _memoWithDisplayName2.default)('UILoadingSpinner', function (props) {
  var dataLoading = props['data-loading'],
      className = props.className,
      failed = props.failed,
      grow = props.grow,
      label = props.label,
      labelCompletedText = props.labelCompletedText,
      layout = props.layout,
      minHeight = props.minHeight,
      onResultDisplayFinish = props.onResultDisplayFinish,
      resultAnimationDuration = props.resultAnimationDuration,
      resultIcon = props.resultIcon,
      showLabel = props.showLabel,
      showResult = props.showResult,
      size = props.size,
      style = props.style,
      use = props.use,
      rest = _objectWithoutProperties(props, ['data-loading', 'className', 'failed', 'grow', 'label', 'labelCompletedText', 'layout', 'minHeight', 'onResultDisplayFinish', 'resultAnimationDuration', 'resultIcon', 'showLabel', 'showResult', 'size', 'style', 'use']);

  var resultDisplayTimeoutRef = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (!showResult) return undefined;

    resultDisplayTimeoutRef.current = setTimeout(onResultDisplayFinish, resultAnimationDuration);
    return function () {
      clearTimeout(resultDisplayTimeoutRef.current);
    };
  }, [onResultDisplayFinish, resultAnimationDuration, showResult]);

  var computedLayout = layout || (grow ? 'centered' : 'inline');

  var computedLabelText = showResult && !failed ? (0, _lazyEval2.default)(labelCompletedText) : (0, _lazyEval2.default)(label);

  var RenderedLabel = showLabel ? SpinnerLabel : 'span';
  var renderedLabelProps = {
    children: computedLabelText
  };
  if (showLabel) {
    renderedLabelProps.layout = computedLayout;
  } else {
    renderedLabelProps.className = 'sr-only';
  }

  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);

  var spinnerSizePx = parseInt(getSpinnerSize(shorthandSize), 10);

  return _react2.default.createElement(
    SpinnerOuter,
    _extends({}, rest, {
      className: (0, _classnames2.default)('private-spinner', className),
      style: getComputedStyle(style, grow, minHeight),
      'data-loading': dataLoading !== undefined ? dataLoading : !showResult,
      layout: computedLayout,
      grow: grow,
      use: use
    }),
    _react2.default.createElement(
      SpinnerInner,
      { size: shorthandSize },
      _react2.default.createElement(
        SpinnerWrapper,
        { showResult: showResult },
        _react2.default.createElement(
          Ring,
          {
            height: spinnerSizePx,
            width: spinnerSizePx,
            viewBox: '0 0 50 50',
            stroke: _LoadingConstants.USE_COLORS[use]
          },
          _react2.default.createElement('circle', { cx: '25', cy: '25', r: '22.5', fill: 'none', strokeWidth: '5' }),
          _react2.default.createElement(RingPath, {
            cx: '25',
            cy: '25',
            r: '22.5',
            fill: 'none',
            stroke: _LoadingConstants.USE_INDICATOR_COLORS[use],
            strokeWidth: '5'
          })
        )
      ),
      resultIcon && !failed && _react2.default.createElement(
        ResultSpinner,
        { showResult: showResult },
        _react2.default.createElement(_UIIconHolder2.default, {
          innerStyles: resultIconStyles,
          name: resultIcon,
          color: _LoadingConstants.ICON_COLOR_MAP[use],
          size: _LoadingConstants.ICON_SIZE_MAP[shorthandSize] || _LoadingConstants.ICON_SIZE_MAP['sm']
        })
      )
    ),
    _react2.default.createElement(RenderedLabel, renderedLabelProps)
  );
});

UILoadingSpinner.propTypes = {
  'data-loading': _propTypes2.default.bool,
  failed: _propTypes2.default.bool,
  showResult: _propTypes2.default.bool,
  label: (0, _createLazyPropType2.default)(_propTypes2.default.node).isRequired,
  labelCompletedText: (0, _createLazyPropType2.default)(_propTypes2.default.node).isRequired,
  layout: _propTypes2.default.oneOf(['inline', 'centered']),
  minHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  grow: _propTypes2.default.bool,
  resultAnimationDuration: _propTypes2.default.number.isRequired,
  resultIcon: _propTypes2.default.string,
  use: _propTypes2.default.oneOf(_LoadingConstants.USES),
  showLabel: _propTypes2.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md']),
  onResultDisplayFinish: _propTypes2.default.func
};

UILoadingSpinner.defaultProps = {
  failed: false,
  grow: false,
  label: function label() {
    return _I18n2.default.text('ui.UILoadingSpinner.busyText');
  },
  labelCompletedText: function labelCompletedText() {
    return _I18n2.default.text('ui.UILoadingSpinner.completedText');
  },
  showResult: false,
  resultAnimationDuration: 1500,
  resultIcon: 'success',
  role: 'status',
  onResultDisplayFinish: _emptyFunction2.default,
  showLabel: false,
  size: 'sm',
  use: 'link'
};

exports.default = UILoadingSpinner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/loading/UILoadingSpinner.js
// module id = 598
// module chunks = 177